import { Absent_getInstance3t0okspv6nz5y as Absent_getInstance } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SavePartyInputClass;
function SavePartyInput() {
  if (SavePartyInputClass === VOID) {
    class $ {
      constructor(partyId, name, email, pairingRule, badgesEnabled, defaultBadgeName, alternateBadgeName, callSignsEnabled, animationsEnabled, animationSpeed) {
        name = name === VOID ? Absent_getInstance() : name;
        email = email === VOID ? Absent_getInstance() : email;
        pairingRule = pairingRule === VOID ? Absent_getInstance() : pairingRule;
        badgesEnabled = badgesEnabled === VOID ? Absent_getInstance() : badgesEnabled;
        defaultBadgeName = defaultBadgeName === VOID ? Absent_getInstance() : defaultBadgeName;
        alternateBadgeName = alternateBadgeName === VOID ? Absent_getInstance() : alternateBadgeName;
        callSignsEnabled = callSignsEnabled === VOID ? Absent_getInstance() : callSignsEnabled;
        animationsEnabled = animationsEnabled === VOID ? Absent_getInstance() : animationsEnabled;
        animationSpeed = animationSpeed === VOID ? Absent_getInstance() : animationSpeed;
        this.v6p_1 = partyId;
        this.w6p_1 = name;
        this.x6p_1 = email;
        this.y6p_1 = pairingRule;
        this.z6p_1 = badgesEnabled;
        this.a6q_1 = defaultBadgeName;
        this.b6q_1 = alternateBadgeName;
        this.c6q_1 = callSignsEnabled;
        this.d6q_1 = animationsEnabled;
        this.e6q_1 = animationSpeed;
      }
      toString() {
        return 'SavePartyInput(partyId=' + this.v6p_1.toString() + ', name=' + toString(this.w6p_1) + ', email=' + toString(this.x6p_1) + ', pairingRule=' + toString(this.y6p_1) + ', badgesEnabled=' + toString(this.z6p_1) + ', defaultBadgeName=' + toString(this.a6q_1) + ', alternateBadgeName=' + toString(this.b6q_1) + ', callSignsEnabled=' + toString(this.c6q_1) + ', animationsEnabled=' + toString(this.d6q_1) + ', animationSpeed=' + toString(this.e6q_1) + ')';
      }
      hashCode() {
        var result = this.v6p_1.hashCode();
        result = imul(result, 31) + hashCode(this.w6p_1) | 0;
        result = imul(result, 31) + hashCode(this.x6p_1) | 0;
        result = imul(result, 31) + hashCode(this.y6p_1) | 0;
        result = imul(result, 31) + hashCode(this.z6p_1) | 0;
        result = imul(result, 31) + hashCode(this.a6q_1) | 0;
        result = imul(result, 31) + hashCode(this.b6q_1) | 0;
        result = imul(result, 31) + hashCode(this.c6q_1) | 0;
        result = imul(result, 31) + hashCode(this.d6q_1) | 0;
        result = imul(result, 31) + hashCode(this.e6q_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePartyInput()))
          return false;
        if (!this.v6p_1.equals(other.v6p_1))
          return false;
        if (!equals(this.w6p_1, other.w6p_1))
          return false;
        if (!equals(this.x6p_1, other.x6p_1))
          return false;
        if (!equals(this.y6p_1, other.y6p_1))
          return false;
        if (!equals(this.z6p_1, other.z6p_1))
          return false;
        if (!equals(this.a6q_1, other.a6q_1))
          return false;
        if (!equals(this.b6q_1, other.b6q_1))
          return false;
        if (!equals(this.c6q_1, other.c6q_1))
          return false;
        if (!equals(this.d6q_1, other.d6q_1))
          return false;
        if (!equals(this.e6q_1, other.e6q_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePartyInput');
    SavePartyInputClass = $;
  }
  return SavePartyInputClass;
}
//region block: exports
export {
  SavePartyInput as SavePartyInput3ikp23en56cie,
};
//endregion

//# sourceMappingURL=SavePartyInput.mjs.map
